import { TApiKeyRevealMode, TRevealCopy } from '../../types/settings/api-key-reveal-modal.type';

export const REVEAL_COPY: Record<TApiKeyRevealMode, TRevealCopy> = {
  created: { titleKey: 'SETTINGS.API_SETTINGS.CREATED_TITLE', subtitleKey: 'SETTINGS.API_SETTINGS.CREATED_SUBTITLE' },
  rotated: { titleKey: 'SETTINGS.API_SETTINGS.ROTATED_TITLE', subtitleKey: 'SETTINGS.API_SETTINGS.ROTATED_SUBTITLE' },
};
